var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.1429C11.9449 15.1429 15.1429 11.9449 15.1429 8C15.1429 4.05511 11.9449 0.857147 8 0.857147C4.05511 0.857147 0.857147 4.05511 0.857147 8C0.857147 11.9449 4.05511 15.1429 8 15.1429Z",
    fill: "#D1FAE5",
    stroke: "#059669",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14287 8.71428L7.22079 10.8571C8.19858 8.04836 9.0129 6.81584 10.8572 5.14285",
    stroke: "#059669",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.10c6bd12cd7eda076996231e792bb6ed.svg";
export { ForwardRef as ReactComponent };